import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type TThemeMode = 'light' | 'dark'

interface IThemeState {
  mode: TThemeMode
  toggleMode: () => void
}

export const useThemeStore = create<IThemeState>()(
  persist(
    (set) => ({
      mode: 'light',
      toggleMode: () => set((state) => ({ mode: state.mode === 'light' ? 'dark' : 'light' }))
    }),
    {
      name: 'untool-mage-theme'
    }
  )
)
